export default {
    quickStart: {
        eyebrow: 'A QUICK START',
        titleFirst: 'Your sessions.',
        titleSecond: 'In one place.',
        description: 'Manage booking requests, plan your time, and keep your host profile ready for customers.',
        howItWorks: 'How it works',
        dismiss: 'Dismiss Host Workspace guide',
        sectionsLabel: 'Host Workspace views',
        footnote: 'Use Share your booking page to copy your link and send it to someone who wants to book you.',
        sections: {
            bookings: {
                title: 'Bookings',
                description: 'Review requests in Waiting on you. Accept or reject them, then track upcoming and past sessions.',
                example: 'Example: confirm a hosted interview for next week.',
            },
            calendar: {
                title: 'Calendar',
                description: 'See your sessions by day. Use the calendar connections available here to keep track of your schedule.',
                example: 'Example: check what’s booked before planning your week.',
            },
            profile: {
                title: 'Profile',
                description: 'Update your bio, hours, and services. Set whether you’re taking bookings, then save your changes.',
                example: 'Example: add morning hours for hosted interviews.',
            },
        },
    },
}
